import { Select } from 'antd';
import { useEffect, useState } from 'react';
import { getOrderActionOptions } from '../common/utils';

const SelectComponent = (props) => {
  const {
    children,
    className = '',
    noPopupContainer,
    options,
    disableFulfill,
    record,
    maxTagCount = 'responsive',
    open,
    onDropdownVisibleChange,
    ...rest
  } = props;
  const [isOpen, setIsOpen] = useState(false);
  const isDropdownOpen = open === undefined ? isOpen : open;

  const handleDropdownVisibleChange = (visible) => {
    setIsOpen(visible);
    if (onDropdownVisibleChange) onDropdownVisibleChange(visible);
  };

  useEffect(() => {
    if (!isDropdownOpen) return undefined;
    const handleScroll = (event) => {
      if (event?.target?.closest?.('.ant-select-dropdown')) return;
      setIsOpen(false);
    };
    // eslint-disable-next-line no-undef
    document?.addEventListener('scroll', handleScroll, true);
    return () => {
      // eslint-disable-next-line no-undef
      document?.removeEventListener('scroll', handleScroll, true);
    };
  }, [isDropdownOpen]);

  return (
    <Select
      showAction={['focus']}
      className={`select-width ${className}`}
      placeholder="Select or Search"
      optionFilterProp="children"
      placement="bottomLeft"
      // eslint-disable-next-line no-undef
      getPopupContainer={noPopupContainer ? undefined : () => document?.body}
      showSearch
      allowClear
      maxTagCount={maxTagCount === null ? undefined : maxTagCount}
      options={
        disableFulfill
          ? getOrderActionOptions(record, options, disableFulfill)
          : options
      }
      {...rest}
      open={isDropdownOpen}
      onDropdownVisibleChange={handleDropdownVisibleChange}
    >
      {children}
    </Select>
  );
};

export default SelectComponent;

SelectComponent.Option = Select?.Option;
SelectComponent.OptGroup = Select?.OptGroup;
